import { Guid, Nillable } from '@web/utils';
import { PaymentMethodCode } from '../../shared/enums/payment-method-code';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicPaymentMethodProperty } from './public-payment-method-property';

export class PublicCartPaymentMethod {
  public constructor(
    private readonly data: {
      id: Guid;
      code: PaymentMethodCode;
      name: string;
      description: string;
      properties: PublicPaymentMethodProperty[];
      previewFile?: Nillable<Multimedia>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get code(): PaymentMethodCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): string {
    return this.data.description;
  }

  public get properties(): PublicPaymentMethodProperty[] {
    return this.data.properties;
  }

  public get previewFile(): Nillable<Multimedia> {
    return this.data.previewFile;
  }

  public isPayURecursive(): boolean {
    return this.data.code === PaymentMethodCode.PayURecursive;
  }
}
